import { Plane, Ship, Truck, MapPin, CheckCircle2 } from "lucide-react";

// Live origin -> destination tracker built from milestone state. Safe to show a customer.
export function RouteTracker({ lane = "", mode = "", milestones = [], eta }) {
  const [origin, dest] = lane.split("→").map((s) => s.trim());
  const done = milestones.filter((m) => m.state === "done").length;
  const total = milestones.length || 1;
  const active = milestones.find((m) => m.state === "active");
  const pct = Math.min(100, Math.round((done / total) * 100));
  const isSea = /sea|lcl|fcl|ocean/i.test(mode);
  const isDelivered = pct >= 100 || milestones.some((m) => /pod|deliver/i.test(m.key) && m.state === "done");
  const Vehicle = isDelivered ? Truck : isSea ? Ship : Plane;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="route-tracker">
      <div className="flex items-center justify-between mb-4">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Live tracking · {mode}</div>
        <div className="text-[11px] font-medium text-indigo-600">
          {isDelivered ? "Delivered" : active ? active.key : "In transit"}{eta ? ` · ETA ${eta}` : ""}
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-center shrink-0 w-24">
          <MapPin className="h-4 w-4 text-slate-400 mx-auto" />
          <div className="text-[12px] font-semibold text-slate-700 truncate">{origin || "Origin"}</div>
        </div>
        <div className="relative flex-1 h-1.5 rounded-full bg-slate-100">
          <div className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-indigo-400 to-emerald-400 transition-all duration-500" style={{ width: `${pct}%` }} />
          <div className="absolute -top-3 -translate-x-1/2 transition-all duration-500" style={{ left: `${pct}%` }}>
            <div className="h-7 w-7 rounded-full bg-white border-2 border-indigo-500 flex items-center justify-center shadow-sm">
              <Vehicle className="h-3.5 w-3.5 text-indigo-600" />
            </div>
          </div>
        </div>
        <div className="text-center shrink-0 w-24">
          {isDelivered ? <CheckCircle2 className="h-4 w-4 text-emerald-500 mx-auto" /> : <MapPin className="h-4 w-4 text-slate-400 mx-auto" />}
          <div className="text-[12px] font-semibold text-slate-700 truncate">{dest || "Destination"}</div>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-1.5 overflow-x-auto pb-1">
        {milestones.map((m, i) => (
          <div key={m.key + i} className="flex items-center gap-1.5 shrink-0" data-testid={`track-stage-${i}`}>
            <span className={`h-2 w-2 rounded-full ${m.state === "done" ? "bg-emerald-500" : m.state === "active" ? "bg-indigo-500 pulse-dot" : "bg-slate-200"}`} />
            <span className={`text-[10px] whitespace-nowrap ${m.state === "done" ? "text-slate-400" : m.state === "active" ? "text-slate-800 font-semibold" : "text-slate-300"}`}>{m.key}</span>
            {i < milestones.length - 1 && <span className="text-slate-200">›</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
